'use strict';

var main = require('./lib/main');

module.exports = main;

